module.exports = __webpack_public_path__ + "img/gloves.81e6f55b.svg";